import React, { useEffect, useState } from "react"
import { CircularProgress, Typography } from "@mui/material"
import { useDataProvider } from "react-admin"
import { ColumnChart } from "react-chartkick"
import "chartkick/chart.js"

const APICallsByDay = ({ numberOfDays = 31, companyId = null, hideInternalUsers = true }) => {
    const [stats, setStats] = useState([])
    const [fetching, setFetching] = useState(true)
    const [total, setTotal] = useState(0)

    const dataProvider = useDataProvider()

    useEffect(() => {
        dataProvider
            .get(
                "/stats/created_templates_by_day?hide_internal_users=" +
                    hideInternalUsers +
                    "&number_of_days=" +
                    numberOfDays +
                    (companyId ? "&company_id=" + companyId : "")
            )
            .then(results => {
                if (results) {
                    setTotal(results.data.last_x_days.map(d => d.total).reduce((a, b) => a + b, 0))
                    setStats(
                        results.data.last_x_days.map(d => {
                            return [d.created_date.split("T")[0].split("-").slice(1).reverse().join("/"), d.total]
                        })
                    )
                    setFetching(false)
                }
            })
            .catch(e => {
                if (process.env.NODE_ENV !== "production") {
                    console.error(e)
                }
            })
    }, [dataProvider, companyId, hideInternalUsers, numberOfDays])

    if (fetching) {
        return <CircularProgress />
    }

    return (
        <>
            <Typography component="h1" variant="h5" align="center" gutterBottom>
                {total} Created Templates <i>(Last {numberOfDays} days)</i>
            </Typography>
            <ColumnChart data={stats} colors={["#BDD69A"]} />
        </>
    )
}

export default APICallsByDay
